import React from 'react';

export const Directors_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>DIRECTORES</span>,
  },
];

export const Director_Nuno = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>NUNO</em>
        <br />
        <strong>GÓMES</strong>
      </span>
    ),
  },
];

export const Director_Bernardo = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>BERNARDO</em>
        <br />
        <strong>VÁZQUEZ</strong>
      </span>
    ),
  },
];

export const Director_Maria = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>MARÍA JOSÉ</em>
        <br />
        <strong>NORIEGA</strong>
      </span>
    ),
  },
];

export const Director_Carlos = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>CARLOS</em>
        <br />
        <strong>MORETT</strong>
      </span>
    ),
  },
];

export const Director_Rodrigo = [
  {
    textSize: '2.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>RODRIGO</em>
        <br />
        <strong>ROBLES</strong>
      </span>
    ),
  },
];

export const Text_Nuno = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Nuno Gómes es guionista, productor y director con base entre Miami y Los
        Ángeles, con una trayectoria de 390+ proyectos en videoclips,
        comerciales y contenido narrativo. Su trabajo suma dos nominaciones al
        Latin Grammy, más de 8 mil millones de vistas en YouTube, y
        colaboraciones con artistas internacionales de primer nivel. Ha dirigido
        150+ comerciales para marcas como Pepsi, Gatorade, HBO Brasil y Spectrum
        Mobile, y es creador de dos series originales para Disney+.
      </span>
    ),
  },
];

export const TextVideo1_Nuno = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>DADDY YANKEE X JUSTIN QUILES X DALEX - "LA HORA Y EL DIA"</span>
    ),
  },
];

export const TextVideo2_Nuno = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>LEONEL GARCÍA - "SÁLVANOS"</span>,
  },
];

export const TextVideo3_Nuno = [
  {
    textSize: '0.813rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>CARIN LEÓN X ALEJANDRO FERNÁNDEZ - “ME ESTÁ DOLIENDO”</span>
    ),
  },
];

export const TextVideo4_Nuno = [
  {
    textSize: '0.813rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>OZUNA x TOKISCHA - "SOMOS IGUALES"</span>,
  },
];

export const Text_Maria = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        María José Noriega es productora y directora, parte del equipo de Lucky
        Twins Films. Su trabajo se enfoca en el desarrollo y ejecución de
        proyectos audiovisuales con una visión narrativa sólida y una producción
        cuidada, participando en contenidos comerciales y cinematográficos que
        priorizan el storytelling, la estética y la eficiencia en set.
      </span>
    ),
  },
];

export const TextVideo1_Maria = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PUMA - Jersey Alternativo Rayados</span>,
  },
];

export const TextVideo2_Maria = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Cicatrices</span>,
  },
];

export const TextVideo3_Maria = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>BILLBOARD X MAJO AGUILAR</span>,
  },
];

export const TextVideo4_Maria = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FACEBOOK X NAILDREAMS</span>,
  },
];

export const Text_Bernardo = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Bernardo Vázquez es un director mexicano especialista en el cuidado de
        la estética, es un apasionado en el lenguaje cinematográfico, ha logrado
        en poco tiempo llamar la atención en el medio. Empezó su carrera como
        director realizando videoclips, tiene experiencia en dirección de niños
        y ha realizado comerciales para productos de beauty and care, destacando
        en cabello.
      </span>
    ),
  },
];

export const TextVideo1_Bernardo = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CHARLY</span>,
  },
];

export const TextVideo2_Bernardo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>UNIFIN</span>,
  },
];

export const TextVideo3_Bernardo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>HARLEY DAVIDSON</span>,
  },
];

export const TextVideo4_Bernardo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PINEDA COVELIN</span>,
  },
];

export const Text_Carlos = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Carlos Morett es un director con experiencia en cine y publicidad, con
        trayectoria en México, España y Estados Unidos. Dirigió el largometraje
        original de Netflix La Rebelión de los Godínez (2020), producido por
        Corazón Films, y ha realizado campañas para marcas como Pepsi,
        Coca-Cola, Cinemex y la NFL. Su perfil combina dirección narrativa,
        visión comercial y ejecución estratégica.
      </span>
    ),
  },
];

export const TextVideo1_Carlos = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>MICTLÁN</span>,
  },
];

export const TextVideo2_Carlos = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>LA REBELIÓN DE LOS GODÍNEZ</span>,
  },
];

export const TextVideo3_Carlos = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>POPCON</span>,
  },
];

export const TextVideo4_Carlos = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>COCA-COLA</span>,
  },
];

export const Text_Rodrigo = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Rodrigo Robles Joseph es un director con enfoque cinematográfico,
        especializado en piezas comerciales e institucionales con narrativa
        clara, ritmo y atmósfera. Su trabajo destaca por un lenguaje visual
        limpio y emocional, cuidando cada detalle desde el concepto hasta el
        rodaje. Su pieza “Tequila Solarum – Leyenda” fue nominada finalista en
        el XXVII Festival Pantalla de Cristal 2025.
      </span>
    ),
  },
];

export const TextVideo1_Rodrigo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => (
      <span>Mon Laferte, Alejandro Fernández - Que Se Sepa Nuestro Amor</span>
    ),
  },
];

export const TextVideo2_Rodrigo = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Salón Acapulco - Jamba Jamba</span>,
  },
];

export const TextVideo3_Rodrigo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>inter.mx</span>,
  },
];

export const TextVideo4_Rodrigo = [
  {
    textSize: '1.5rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>Tequila Código 1530</span>,
  },
];
